/**
 * Вертика «автозапчастини для легкових»: єдиний розділ parts-cars із 19 групами
 * (Кузов, Скло, Двигун…), плюс «Шини, диски» й «Аксесуари». Головна показує
 * саме групи (homeGroups). Загальні (не-авто) категорії та вантажні/мото/агро
 * розділи залишаються в коді з visible: false — повернення тематик у майбутньому
 * = прибрати прапорець. Старі id, що зникли, мапляться через legacyCategoryAliases,
 * історичні оголошення не губляться.
 */
export const categories = [
    {
        id: 'parts-cars',
        name: 'Легкові автозапчастини',
        nameKey: 'cat.parts-cars',
        icon: '🔧',
        subcategories: [
            { id: 'parts-engine', name: 'Двигун', nameKey: 'cat.parts-engine', icon: '⚙️' },
            {
                id: 'parts-transmission',
                name: 'Трансмісія і зчеплення',
                nameKey: 'cat.parts-transmission',
                icon: '🔗',
            },
            { id: 'parts-body', name: 'Кузов і екстерʼєр', nameKey: 'cat.parts-body', icon: '🚙' },
            { id: 'parts-optics', name: 'Оптика і світло', nameKey: 'cat.parts-optics', icon: '💡' },
            { id: 'parts-glass', name: 'Скло і дзеркала', nameKey: 'cat.parts-glass', icon: '🪟' },
            { id: 'parts-suspension', name: 'Підвіска і ходова', nameKey: 'cat.parts-suspension', icon: '🌀' },
            { id: 'parts-brakes', name: 'Гальмівна система', nameKey: 'cat.parts-brakes', icon: '🛑' },
            {
                id: 'parts-steering',
                name: 'Рульове управління',
                nameKey: 'cat.parts-steering',
                icon: '🧭',
            },
            { id: 'parts-electrics', name: 'Електрика і АКБ', nameKey: 'cat.parts-electrics', icon: '🔋' },
            { id: 'parts-cooling', name: 'Охолодження і клімат', nameKey: 'cat.parts-cooling', icon: '❄️' },
            { id: 'parts-fuel', name: 'Паливна система і ГБО', nameKey: 'cat.parts-fuel', icon: '⛽' },
            { id: 'parts-exhaust', name: 'Вихлопна система', nameKey: 'cat.parts-exhaust', icon: '💨' },
            { id: 'parts-interior', name: 'Салон і інтерʼєр', nameKey: 'cat.parts-interior', icon: '🪑' },
            { id: 'parts-ev', name: 'ЕВ-компоненти', nameKey: 'cat.parts-ev', icon: '🔌' },
            { id: 'parts-filters', name: 'Фільтри', nameKey: 'cat.parts-filters', icon: '♻️' },
            { id: 'parts-sensors', name: 'Датчики', nameKey: 'cat.parts-sensors', icon: '📡' },
            { id: 'parts-locks', name: 'Замки', nameKey: 'cat.parts-locks', icon: '🔐' },
            { id: 'parts-wipers', name: 'Склоочисники', nameKey: 'cat.parts-wipers', icon: '🌧️' },
            { id: 'parts-cars-other', name: 'Інше', nameKey: 'cat.parts-cars-other', icon: '📦' },
        ],
    },
    // --- Приховані розділи вертикалі запчастин (легковий формат) ---
    // Вантажні/сільгосп/мото/розбірка/інші запчастини: id лишаються валідними
    // для старих оголошень, але на головній і у створенні їх немає.
    {
        id: 'parts-trucks',
        name: 'Вантажні автозапчастини',
        nameKey: 'cat.parts-trucks',
        icon: '🚛',
        visible: false,
        subcategories: [
            { id: 'parts-trucks-cabin', name: 'Кабіна', nameKey: 'cat.parts-trucks-cabin', icon: '🏠' },
            {
                id: 'parts-trucks-hydraulics',
                name: 'Гідравліка',
                nameKey: 'cat.parts-trucks-hydraulics',
                icon: '🛠️',
            },
            {
                id: 'parts-trucks-chassis',
                name: 'Ходова і рама',
                nameKey: 'cat.parts-trucks-chassis',
                icon: '🔩',
            },
            {
                id: 'parts-trucks-engine',
                name: 'Двигун',
                nameKey: 'cat.parts-trucks-engine',
                icon: '⚙️',
            },
            { id: 'parts-trucks-other', name: 'Інше', nameKey: 'cat.parts-trucks-other', icon: '📦' },
        ],
    },
    {
        id: 'parts-agri',
        name: 'Сільгосптехніка і спецтехніка',
        nameKey: 'cat.parts-agri',
        icon: '🚜',
        visible: false,
    },
    {
        id: 'parts-moto',
        name: 'Мотозапчастини',
        nameKey: 'cat.parts-moto',
        icon: '🏍️',
        visible: false,
    },
    {
        id: 'parts-wheels',
        name: 'Шини, диски і колеса',
        nameKey: 'cat.parts-wheels',
        icon: '🛞',
        subcategories: [
            { id: 'parts-tires', name: 'Шини', nameKey: 'cat.parts-tires', icon: '⭕' },
            { id: 'parts-rims', name: 'Диски', nameKey: 'cat.parts-rims', icon: '💿' },
            { id: 'parts-wheelsets', name: 'Колеса в зборі', nameKey: 'cat.parts-wheelsets', icon: '🛞' },
        ],
    },
    {
        id: 'parts-accessories',
        name: 'Аксесуари і автотовари',
        nameKey: 'cat.parts-accessories',
        icon: '🎒',
        subcategories: [
            { id: 'parts-audio', name: 'Автоаудіо і відео', nameKey: 'cat.parts-audio', icon: '🎵' },
            { id: 'parts-chem', name: 'Автохімія і мастила', nameKey: 'cat.parts-chem', icon: '🧪' },
            { id: 'parts-tuning', name: 'Тюнинг і захист', nameKey: 'cat.parts-tuning', icon: '🎨' },
            { id: 'parts-acc-other', name: 'Інше', nameKey: 'cat.parts-acc-other', icon: '📦' },
        ],
    },
    {
        id: 'parts-breakers',
        name: 'Авторозбірка',
        nameKey: 'cat.parts-breakers',
        icon: '🏚️',
        visible: false,
    },
    {
        id: 'parts-other',
        name: 'Інші запчастини',
        nameKey: 'cat.parts-other',
        icon: '📦',
        visible: false,
    },
    // --- Загальні категорії: приховані до повернення решти тематик ---
    {
        id: 'electronics',
        name: 'Електроніка',
        nameKey: 'cat.electronics',
        icon: '📱',
        visible: false,
        subcategories: [
            { id: 'electronics-phones', name: 'Телефони', nameKey: 'cat.electronics-phones', icon: '📱' },
            {
                id: 'electronics-laptops',
                name: 'Ноутбуки та компʼютери',
                nameKey: 'cat.electronics-laptops',
                icon: '💻',
            },
            { id: 'electronics-tv', name: 'ТВ та аудіо', nameKey: 'cat.electronics-tv', icon: '📺' },
            { id: 'electronics-photo', name: 'Фото та відео', nameKey: 'cat.electronics-photo', icon: '📷' },
            { id: 'electronics-games', name: 'Ігри та приставки', nameKey: 'cat.electronics-games', icon: '🎮' },
        ],
    },
    {
        id: 'home',
        name: 'Дім і сад',
        nameKey: 'cat.home',
        icon: '🏠',
        visible: false,
        subcategories: [
            { id: 'home-furniture', name: 'Меблі', nameKey: 'cat.home-furniture', icon: '🛋️' },
            { id: 'home-appliances', name: 'Побутова техніка', nameKey: 'cat.home-appliances', icon: '🧺' },
            { id: 'home-dishes', name: 'Посуд', nameKey: 'cat.home-dishes', icon: '🍽️' },
            { id: 'home-tools', name: 'Інструменти', nameKey: 'cat.home-tools', icon: '🪛' },
            { id: 'home-garden', name: 'Сад і город', nameKey: 'cat.home-garden', icon: '🌱' },
            { id: 'home-build', name: 'Будматеріали', nameKey: 'cat.home-build', icon: '🧱' },
        ],
    },
    {
        id: 'clothing',
        name: 'Одяг і взуття',
        nameKey: 'cat.clothing',
        icon: '👕',
        visible: false,
        subcategories: [
            { id: 'clothing-women', name: 'Жіночий', nameKey: 'cat.clothing-women', icon: '👗' },
            { id: 'clothing-men', name: 'Чоловічий', nameKey: 'cat.clothing-men', icon: '👔' },
            { id: 'clothing-kids', name: 'Дитячий', nameKey: 'cat.clothing-kids', icon: '🧒' },
            { id: 'clothing-accessories', name: 'Сумки та аксесуари', nameKey: 'cat.clothing-accessories', icon: '👜' },
        ],
    },
    {
        id: 'kids',
        name: 'Дитячі товари',
        nameKey: 'cat.kids',
        icon: '🧸',
        visible: false,
        subcategories: [
            { id: 'kids-toys', name: 'Іграшки', nameKey: 'cat.kids-toys', icon: '🪀' },
            { id: 'kids-strollers', name: 'Коляски та автокрісла', nameKey: 'cat.kids-strollers', icon: '🍼' },
            { id: 'kids-furniture', name: 'Дитячі меблі', nameKey: 'cat.kids-furniture', icon: '🛏️' },
            { id: 'kids-school', name: 'Товари для школярів', nameKey: 'cat.kids-school', icon: '🎒' },
        ],
    },
    {
        // Підкатегорії прибрані: їхні id переливаються через legacyCategoryAliases
        // у нові parts-* розділи (міграція v21).
        id: 'auto',
        name: 'Авто і транспорт',
        nameKey: 'cat.auto',
        icon: '🚗',
        visible: false,
    },
    {
        id: 'sport',
        name: 'Хобі і спорт',
        nameKey: 'cat.sport',
        icon: '⚽',
        visible: false,
        subcategories: [
            { id: 'sport-gear', name: 'Спорт і туризм', nameKey: 'cat.sport-gear', icon: '🏋️' },
            { id: 'sport-books', name: 'Книги', nameKey: 'cat.sport-books', icon: '📚' },
            { id: 'sport-music', name: 'Музичні інструменти', nameKey: 'cat.sport-music', icon: '🎸' },
            { id: 'sport-collections', name: 'Колекції та антикваріат', nameKey: 'cat.sport-collections', icon: '🖼️' },
        ],
    },
    {
        id: 'animals',
        name: 'Тварини',
        nameKey: 'cat.animals',
        icon: '🐾',
        visible: false,
        subcategories: [
            { id: 'animals-supplies', name: 'Зоотовари', nameKey: 'cat.animals-supplies', icon: '🦴' },
            { id: 'animals-adopt', name: 'В добрі руки', nameKey: 'cat.animals-adopt', icon: '🐕' },
        ],
    },
    {
        id: 'beauty',
        name: 'Краса і здоровʼя',
        nameKey: 'cat.beauty',
        icon: '💄',
        visible: false,
    },
    {
        id: 'services',
        name: 'Послуги',
        nameKey: 'cat.services',
        icon: '🛎️',
        visible: false,
        subcategories: [
            {
                id: 'services-construction',
                name: 'Будівництво та ремонт',
                nameKey: 'cat.services-construction',
                icon: '🏗️',
            },
            { id: 'services-repair', name: 'Ремонт техніки', nameKey: 'cat.services-repair', icon: '🛠️' },
            { id: 'services-auto-repair', name: 'Автопослуги', nameKey: 'cat.services-auto-repair', icon: '🔧' },
            { id: 'services-transport', name: 'Перевезення', nameKey: 'cat.services-transport', icon: '🚚' },
            { id: 'services-cleaning', name: 'Прибирання', nameKey: 'cat.services-cleaning', icon: '🧹' },
            {
                id: 'services-education',
                name: 'Навчання і репетиторство',
                nameKey: 'cat.services-education',
                icon: '🎓',
            },
            { id: 'services-beauty', name: 'Краса і здоровʼя', nameKey: 'cat.services-beauty', icon: '💇' },
            { id: 'services-it', name: 'IT та компʼютери', nameKey: 'cat.services-it', icon: '💻' },
            { id: 'services-photo', name: 'Фото, відео та творчі', nameKey: 'cat.services-photo', icon: '📷' },
            { id: 'services-legal', name: 'Юридичні та нотаріальні', nameKey: 'cat.services-legal', icon: '⚖️' },
        ],
    },
    {
        id: 'free',
        name: 'Віддам безкоштовно',
        nameKey: 'cat.free',
        icon: '🎁',
        visible: false,
    },
    {
        id: 'other',
        name: 'Інше',
        nameKey: 'cat.other',
        icon: '📦',
        visible: false,
    },
];
/** Розділи для створення оголошення (вертика «автозапчастини», без прихованих). */
export const visibleCategories = categories.filter((c) => c.visible !== false);
/**
 * Плитки головної сторінки й фільтр категорій пошуку: 19 груп запчастин
 * легкових (підкатегорії parts-cars) + «Шини, диски» + «Аксесуари».
 */
export const homeGroups = [
    ...(categories.find((c) => c.id === 'parts-cars')?.subcategories ?? []),
    ...categories.filter((c) => c.id === 'parts-wheels' || c.id === 'parts-accessories'),
];
/** id, що зникли при переходах таксономій → нові id. */
export const legacyCategoryAliases = {
    'electronics-tablets': 'electronics',
    tools: 'home-tools',
    'tools-repair': 'home-tools',
    'tools-construction': 'home-build',
    garden: 'home-garden',
    'auto-accessories': 'parts-accessories',
    'auto-parts': 'parts-cars',
    'auto-tires': 'parts-wheels',
    'auto-moto': 'parts-moto',
    'sport-bikes': 'other',
    'sport-trainers': 'sport-gear',
    books: 'sport-books',
    music: 'sport-music',
    'music-instruments': 'sport-music',
    'music-vinyl': 'sport-music',
    art: 'sport-collections',
    'animals-food': 'animals-supplies',
    'animals-accessories': 'animals-supplies',
    business: 'services',
    exchange: 'other',
    'services-notary': 'services-legal',
    'services-event': 'services-photo',
};
export function findCategoryById(id) {
    for (const cat of categories) {
        if (cat.id === id)
            return cat;
        if (cat.subcategories) {
            const found = cat.subcategories.find((sub) => sub.id === id);
            if (found)
                return found;
        }
    }
    return undefined;
}
export function getAllCategoryIds() {
    const ids = [];
    for (const cat of categories) {
        ids.push(cat.id);
        if (cat.subcategories) {
            for (const sub of cat.subcategories) {
                ids.push(sub.id);
            }
        }
    }
    return ids;
}
/** Новий id лишається собою; легасі id мапиться на новий; невідомий → 'other'. */
export function resolveCategoryId(id) {
    if (findCategoryById(id))
        return id;
    const aliased = legacyCategoryAliases[id];
    if (aliased && findCategoryById(aliased))
        return aliased;
    return 'other';
}
/** id категорії + id всіх її підкатегорій (для фільтрів за родителем). */
export function getCategoryIdsWithDescendants(id) {
    const cat = findCategoryById(id) ?? findCategoryById(resolveCategoryId(id));
    if (!cat)
        return [id];
    return [cat.id, ...(cat.subcategories?.map((sub) => sub.id) ?? [])];
}
//# sourceMappingURL=categories.js.map